import React, { useEffect, useRef, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Body from "./pages/Body";
import Willy from "./assets/images/will-crooks-poster.jpeg";
import Willy2 from "./assets/images/will-crooks-poster-2.JPEG";
import { HatsPage } from "./components/HatPage";
import AfterYouPage from "./components/AfterYouPage";
import MollyPage from "./components/MollyPage";
import { BsArrowLeft, BsArrowRightCircle } from "react-icons/bs";
import { BiChevronRight } from "react-icons/bi";
import { LuChevronLeftCircle, LuChevronRightCircle } from "react-icons/lu";
// import MollyPage2 from "./components/MollyPage2";
import RunningbackPage from "./components/RunningbackPage";

export default function Home() {
  const [averageColor, setAverageColor] = useState("rgb(255, 255, 255)");
  const [oppositeColor, setOppositeColor] = useState("#000000");
  const [newsOpen, setNewsOpen] = useState(true);
  const [transitionStarted, setTransitionStarted] = useState(false);
  const [scrollDistance, setScrollDistance] = useState(0);
  const [windowWidth, setWindowWidth] = useState(undefined);
  const canvasRef = useRef();

  useEffect(() => {
    const isNewsAlreadyClosed = localStorage.getItem("yung-men-at-el-cid");
    if (isNewsAlreadyClosed) {
      setNewsOpen(false);
    }
    setWindowWidth(window.innerWidth);
    window.addEventListener("resize", () => {
      setWindowWidth(window.innerWidth);
    });

    const scrollContainer = document.getElementById("scroll-container");
    scrollContainer.addEventListener("scroll", () => {
      setScrollDistance(scrollContainer.scrollLeft);
    });
    return () => {
      scrollContainer.removeEventListener("scroll", () => {
        setScrollDistance(scrollContainer.scrollLeft);
      });
      window.removeEventListener("resize", () => {
        setWindowWidth(window.innerWidth);
      });
    };
  }, []);

  const handleScrollRight = () => {
    const scrollContainer = document.getElementById("scroll-container");
    scrollContainer.scrollBy({
      left: window.innerWidth,
      behavior: "smooth",
    });
  };

  const handleScrollLeft = () => {
    const scrollContainer = document.getElementById("scroll-container");
    scrollContainer.scrollBy({
      left: -window.innerWidth,
      behavior: "smooth",
    });
  };

  const pagesArray = [
    <RunningbackPage />,
    <MollyPage />,
    <AfterYouPage />,
    <Body
      setAverageColor={setAverageColor}
      setOppositeColor={setOppositeColor}
    />,
    <HatsPage />,
  ];

  return (
    <div
      id="scroll-container"
      className="relative flex max-h-[100dvh] overflow-y-hidden"
      style={{
        scrollSnapType: "x mandatory",
        overflowX: "scroll",
        scrollBehavior: "smooth",
      }}
    >
      <Navbar averageColor={averageColor} oppositeColor={oppositeColor} />
      {/*--------------------------- Willy Crooks Poster ---------------------------*/}
      {/* <div
        onClick={() => {
          setTransitionStarted(true);
        }}
        className={`${!newsOpen && "hidden"} absolute z-[100] flex max-h-[100dvh] min-h-[100dvh] min-w-[100vw] flex-col items-center gap-2 overflow-y-scroll bg-[red]/40 px-4 pt-[5dvh] font-[900] text-white transition-all md:gap-3`}
      >
        <p className="z-10 text-[54px] md:text-[80px]">YUNG MEN </p>
        <p className="z-10">AT EL CID</p>
        <p className="z-10 text-[28px] md:text-[34px]">JUNE 27th</p>

        <img
          alt="willy crooks poster"
          src={Willy2}
          className={`flex aspect-square max-h-[80dvh] max-w-[90dvw] ${transitionStarted && "scale-[200] opacity-75 "} cursor-pointer flex-col  transition-all duration-[500ms] `}
          style={{
            imageRendering: "pixelated",
          }}
          onClick={() => {
            window.open(
              "https://dice.fm/partner/dice/event/wn7np-william-crooks-cookie-cali-cartier-yung-men-27th-jun-el-cid-los-angeles-tickets?dice_id=2909193&dice_channel=web&dice_tags=organic&dice_campaign=DICE&dice_feature=mio_marketing&_branch_match_id=1230969828968427028&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXz8nMy9ZLyUxO1UvL1fc3T7NINk0xSTOytAQAvL04SiEAAAA%3D",
              "_blank",
            );
          }}
          onTransitionEnd={() => {
            setNewsOpen(false);
            localStorage.setItem("yung-men-at-el-cid", newsOpen);
          }}
        />
        <div className="animate animate-fade"> Click to Close </div>
      </div> */}
      {pagesArray.map((page, index) => {
        return <div key={index}>{page}</div>;
      })}
      {/*--------------------------- Extra Page Template Start (WILLY SHOW) ---------------------------*/}
      {/* <div
        className="flex h-screen min-h-[100dvh] min-w-[100vw] flex-col items-center overflow-y-scroll bg-[blue] px-4 pt-[10dvh] font-[900] text-white"
        style={{
          scrollSnapAlign: "start",
        }}
      >
        <div className=" flex flex-col lg:hidden">
          <p className="z-10 text-[54px] md:text-[80px]">YUNG MEN </p>
          <p className="z-10">AT EL CID</p>
          <p className="z-10 text-[28px] md:text-[34px]">JUNE 27th</p>

          <img
            alt="willy crooks poster"
            src={Willy2}
            className={`flex aspect-square max-h-[80dvh] max-w-[90dvw] ${transitionStarted && "scale-[200] opacity-75 "} cursor-pointer flex-col  transition-all duration-[500ms] `}
            style={{
              imageRendering: "pixelated",
            }}
            onClick={() => {
              window.open(
                "https://dice.fm/partner/dice/event/wn7np-william-crooks-cookie-cali-cartier-yung-men-27th-jun-el-cid-los-angeles-tickets?dice_id=2909193&dice_channel=web&dice_tags=organic&dice_campaign=DICE&dice_feature=mio_marketing&_branch_match_id=1230969828968427028&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXz8nMy9ZLyUxO1UvL1fc3T7NINk0xSTOytAQAvL04SiEAAAA%3D",
                "_blank",
              );
            }}
            onTransitionEnd={() => {
              setNewsOpen(false);
              localStorage.setItem("yung-men-at-el-cid", newsOpen);
            }}
          />
          <p className="z-10 text-[28px] md:text-[34px]">9:30pm</p>
          <p className="z-10 text-[54px] md:text-[80px]">BE THERE!</p>
        </div>
        <div className="hidden grid-cols-2 gap-2 lg:grid">
          <div className="flex flex-col justify-between">
            <div>
              <p className="z-10 text-[54px] md:text-[80px]">YUNG MEN </p>
              <p className="z-10">AT EL CID</p>
              <p className="z-10 text-[28px] md:text-[34px]">JUNE 27th</p>
            </div>
            <div>
              <p className="z-10 text-[28px] md:text-[34px]">9:30pm</p>
              <p className="z-10 text-[54px] md:text-[80px]">BE THERE!</p>
            </div>
          </div>
          <div className="flex h-[80dvh]  w-full items-center justify-center">
            <img
              alt="willy crooks poster"
              src={Willy2}
              className={`flex aspect-square w-full cursor-pointer flex-col self-center  transition-all duration-[500ms] `}
              onClick={() => {
                window.open(
                  "https://dice.fm/partner/dice/event/wn7np-william-crooks-cookie-cali-cartier-yung-men-27th-jun-el-cid-los-angeles-tickets?dice_id=2909193&dice_channel=web&dice_tags=organic&dice_campaign=DICE&dice_feature=mio_marketing&_branch_match_id=1230969828968427028&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXz8nMy9ZLyUxO1UvL1fc3T7NINk0xSTOytAQAvL04SiEAAAA%3D",
                  "_blank",
                );
              }}
            />
          </div>
        </div>
      </div> */}
      {/*--------------------------- Extra Page Template End ---------------------------*/}
      <Footer color={oppositeColor} />
      {/*--------------------------- Navigation Controls ---------------------------*/}
      {/* <div className="fixed z-[1000] flex flex-col bg-[red]">
        <div>{scrollDistance}</div>
        <div>{windowWidth}</div>
        <div>{windowWidth * (pagesArray.length - 1)}</div>
      </div> */}
      <div className="absolute h-full w-[100vw] ">
        {scrollDistance >= windowWidth && (
          <LuChevronLeftCircle
            className="fixed top-1/2 m-2 h-[max(30px,3vw)] w-[max(30px,3vw)] -translate-y-1/2 cursor-pointer mix-blend-difference"
            // size={30}
            color="white"
            onClick={handleScrollLeft}
          />
        )}
        {scrollDistance < windowWidth * (pagesArray.length - 1) && (
          <LuChevronRightCircle
            className="fixed right-0 top-1/2 m-2 h-[max(30px,3vw)] w-[max(30px,3vw)] -translate-y-1/2 cursor-pointer mix-blend-difference"
            // size={30}
            color="white"
            onClick={handleScrollRight}
          />
        )}
      </div>
    </div>
  );
}

// FUll Screen Filters  {/* <div className="animate-slowFade absolute min-h-screen min-w-[100vw] bg-white mix-blend-difference" /> */}
// <div
// onClick={() => {
//     window.open("https://www.youtube.com/watch?v=OsDB7ZTkeT8", "_blank");
//   }}
//   className={`absolute  z-[2] flex h-full min-w-[100vw]  animate-fade  cursor-pointer select-none items-center justify-center rounded-sm  bg-[purple] py-[20px] text-center tracking-[40px] mix-blend-difference`}
// ></div>;
